import React, { useState, useEffect } from 'react'
import Form from "../../layouts/Form";
import { Grid, InputAdornment, makeStyles, ButtonGroup, Button as MuiButton } from '@material-ui/core';
import { Input, Select, Button } from "../../controls";


import EventBusyIcon from '@mui/icons-material/EventBusy';

import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import ContactMailIcon from '@mui/icons-material/ContactMail';

import { createAPIEndpoint, ENDPIONTS } from "../../api";

import Popup from '../../layouts/Popup';
import Notification from "../../layouts/Notification";
import NotificationExitosa from "../../layouts/NotificationExitosa";
import NotificationReciboRechazado from "../../layouts/NotificationReciboRechazado";
import NotificationUsuarioInvalido from "../../layouts/NotificationUsuarioInvalido";
import InputLabel from '@mui/material/InputLabel';



const useStyles = makeStyles(theme => ({
    adornmentText: {
        '& .MuiTypography-root': {
            color: '#f3b33d',
            fontWeight: 'bolder',
            fontSize: '1.5em'
        }
    },
    submitButtonGroup: {
        backgroundColor: '#6666ff',
        color: '#6666ff',
        margin: theme.spacing(1),
        '& .MuiButton-label': {
            textTransform: 'none'
        },
        '&:hover': {
            backgroundColor: '#f3b33d',
        }
    },
    labelAlumnoCarrito: {
        backgroundColor: '#e6e6e6',
        color: '#ff66a3',
        margin: theme.spacing(1),
        fontSize: 'small'
    }
}))


const generateOrderNumber2 = () => Math.floor(100000 + Math.random() * 900000).toString();

const getFreshModelObject2 = () => ({
    ordernumber: generateOrderNumber2(),
    ordermasterid: '',
    reciboseleccionado:0,
    codigocancelacion: '',
    usuarioautoriza: '',
    claveautoriza: '',
    customerId: 0
})



export default function CancelarReciboForm(props) {

    //console.log("---------***>" + JSON.stringify(props));

    const { values, setValues, errors, setErrors, handleInputChange, resetFormControls, nombrealumno, gradoalumno, nivelalumno, grupoalumno, alumnoid, correo2 } = props;
    const classes = useStyles();


    const [notify, setNotify] = useState({ isOpen: false });

    const [notifyExitosa, setNotifyExitosa] = useState({ isOpen: false });
    const [notifyReciboRechazado, setNotifyReciboRechazado] = useState({ isOpen: false });
    const [notifyUsuarioInvalido, setNotifyUsuarioInvalido] = useState({ isOpen: false });

    const [enviarpago, setEnviarpago] = useState(false);
    const [enviarcodigo, setEnviarcodigo] = useState(false);
    

    const [customerList, setCustomerList] = useState([]);


    //CICLO ESCOLAR
    useEffect(() => {
        createAPIEndpoint(ENDPIONTS.CICLO_ESCOLAR).fetchAll()
            .then(res => {
                let customerList = res.data.map(item => ({
                    id: item.idcicloescolar,
                    title: item.nombre
                }));
                customerList = [{ id: 0, title: 'Selecciona ciclo escolar' }].concat(customerList);
                setCustomerList(customerList);
            })
            .catch(err => console.log(err))
    }, [])

    //ID ALUMNO
    useEffect(() => {
        setValues({
            ...values,
            idalumno: alumnoid,
            idusuario: sessionStorage.getItem('idusuario'),
            alias: sessionStorage.getItem('alias'),
        })

    }, [alumnoid]);

    const validateForm = () => {
        //debugger;
        let temp = {};

        temp.reciboseleccionado = "";
        temp.codigocancelacion  = "";
        temp.usuarioautoriza    = "";
        temp.claveautoriza      = "";


        if (values.reciboseleccionado === 0) {
            temp.reciboseleccionado = "¡Debes seleccionar el número de recibo a cancelar!";
        }

        if (values.codigocancelacion === "") {
            temp.codigocancelacion = "¡Debes ingresar el código de cancelación!";
        }

        if (values.usuarioautoriza === "") {
            temp.usuarioautoriza = "¡Debes ingresar el usuario que autoriza!";
        }

        if (values.claveautoriza === "") {
            temp.claveautoriza = "¡Debes ingresar la clave del usuario!";
        }

        setErrors({ ...temp });
        return Object.values(temp).every(x => x === "");
    }

    const resetForm = () => {

        setValues({
            ...getFreshModelObject2(),
            idalumno: alumnoid,
            idusuario: sessionStorage.getItem('idusuario'),
            alias: sessionStorage.getItem('alias')
        });

        
    }
    
    const submitOrder = e => {
        e.preventDefault();


        if (validateForm()) {

            //console.log("---AAAAA------***>" + JSON.stringify(values));

            setEnviarpago(true);
            createAPIEndpoint(ENDPIONTS.CANCELAR_RECIBO)
                .create(values)
                .then(res => {
                    //console.log("---VALOR RES AAAAA------***>" + JSON.stringify(res));
                    //console.log("---VALOR RES AAAAA------***>" + JSON.stringify(res.data));
                    
                    if (res.data === "usuario-invalido") {
                        setNotifyUsuarioInvalido({ isOpen: true, message: '¡El usuario que autoriza no tiene permiso para realizar esta acción!' });
                    }

                    if (res.data === "codigo-invalido") {
                        setNotifyReciboRechazado({ isOpen: true, message: '¡El código proporcionado no esta asociado al alumno!' });
                    }

                    if (res.data === "proceso-fallido") {
                        setNotifyUsuarioInvalido({ isOpen: true, message: '¡El proceso de cancelación falló, intente nuevamente!' });
                    }

                    if (res.data === "codigo-no-existe") {
                        setNotifyUsuarioInvalido({ isOpen: true, message: '¡El número de recibo fue cancelado previamente o no existe!' });
                    }

                    if (res.data === "OK") {
                        setNotifyExitosa({ isOpen: true, message: '¡El recibo ha sido cancelado de manera exitosa!' });
                        resetForm();
                    }
                    
                    setEnviarpago(false);
                    
                })
                .catch(err => console.log(err));

        }//END IF

    }//END METHOD

    const enviarCodigoCorreo = () => {
        //console.log("---AAAAA------***>" + JSON.stringify(values));

        //"&Idcicloescolar=" + cicloseleccionado;

        var parametros = "?Idalumno=" + values.idalumno + "&" +
            "Codigo=" + values.ordernumber + "&" +
            "Idusuariosolicito=" + values.idusuario + "&" +
            "Aliassolicito=" + values.alias;


        setEnviarcodigo(true);
        createAPIEndpoint(ENDPIONTS.ENVIAR_CODIGO_CANCELACION).enviaCodigoCancelacion(parametros)
            .then(res => {
                setNotify({ isOpen: true, message: '¡El código ha sido enviado al responsable del área!' });
                setEnviarcodigo(false);
            })
            .catch(err => console.log(err))
    }

    

    return (
        <>
            <Form onSubmit={submitOrder}>
                <Grid container>

                    
                    
                    <Grid item>


                        

                        {
                            enviarcodigo ? (
                                    <Button
                                        disabled
                                        size="small"
                                        onClick={enviarCodigoCorreo}
                                    startIcon={<ForwardToInboxIcon />}
                                    className={classes.submitButtonGroup}>
                                        ENVIANDO CODIGO ...</Button>
                                

                            ) : (
                                    <Button
                                        size="small"
                                        onClick={enviarCodigoCorreo}
                                        startIcon={<ContactMailIcon />}>
                                        ENVIAR CODIGO
                                    </Button>

                            )

                        }




                        <InputLabel style={{ color: "#0052cc" }}>
                            {nombrealumno}
                            <br />
                            {gradoalumno} {nivelalumno} - {grupoalumno}
                        </InputLabel>


                        <Input
                            label="ID Sistema"
                            name="reciboseleccionado"
                            value={values.reciboseleccionado}
                            onChange={handleInputChange}
                            error={errors.reciboseleccionado}
                            disabled
                        />

                        <Select
                            label="Ciclo Escolar"
                            name="customerId"
                            value={values.customerId}
                            onChange={handleInputChange}
                            options={customerList}
                            error={errors.customerId} />

                        <Input
                            label="Código Cancelación"
                            name="codigocancelacion"
                            value={values.codigocancelacion}
                            onChange={handleInputChange}
                            error={errors.codigocancelacion}
                        />


                        <Input
                            label="Usuario autoriza"
                            name="usuarioautoriza"
                            value={values.usuarioautoriza}
                            onChange={handleInputChange}
                            error={errors.usuarioautoriza}
                        />


                        <Input
                            label="Clave autoriza"
                            name="claveautoriza"
                            value={values.claveautoriza}
                            onChange={handleInputChange}
                            error={errors.claveautoriza}
                        />                        


                        {
                            enviarpago ? (
                                <ButtonGroup className={classes.submitButtonGroup} disabled>
                                    <MuiButton
                                        size="small"
                                        endIcon={<EventBusyIcon />}
                                        type="submit">PROCESANDO CANCELACION</MuiButton>
                                    
                                </ButtonGroup>

                            ) : (
                                <ButtonGroup className={classes.submitButtonGroup}>
                                    <MuiButton
                                            size="small"
                                            endIcon={<EventBusyIcon />}
                                        type="submit">CANCELAR</MuiButton>
                                    
                                </ButtonGroup>

                            )

                        }



                    </Grid>

                </Grid>
            </Form>
            <Notification {...{ notify, setNotify }} />
            <NotificationExitosa {...{ notifyExitosa, setNotifyExitosa }} />
            <NotificationReciboRechazado {...{ notifyReciboRechazado, setNotifyReciboRechazado }} />
            <NotificationUsuarioInvalido {...{ notifyUsuarioInvalido, setNotifyUsuarioInvalido }} />

        </>
    )
}
